// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import React from 'react'
import { array, string } from 'prop-types'
import usePathCartActionsContext from 'components/PathCart/hooks/usePathCartActionsContext'
import usePathCartStoreContext from 'components/PathCart/hooks/usePathCartStoreContext'
import PathCartToggle from 'components/PathCart/PathCartToggle'

const PathDatabaseSearchPathCartTrigger = props => {
  const {
    idRoot,
    results,
  } = props

  const pathCartStore = usePathCartStoreContext()

  const {
    addPathsToCartStore,
    removePathsById,
  } = usePathCartActionsContext()

  const selectAllChecked = (
    // if there are visible paths and
    results.length > 0 &&
    // all the visible paths are stored in the cart.
    results.every(d => (
      pathCartStore.find(dd => dd.pathId === d.pathId)
    ))
  )

  const handleChange = () => (
    selectAllChecked
      ? removePathsById(results.map(d => d.pathId))
      : addPathsToCartStore(results)
  )

  return (
    <div className={'display-flex align-items-center'}>
      <p
        className={'margin-right-1'}
        id={`${idRoot}-path-cart-selected-count`}>
        {`${pathCartStore.length} path${pathCartStore.length === 1 ? '' : 's'} selected.`}
      </p>
      <label className={'pointer display-flex align-items-center margin-left-half margin-right-half'}>
        <span className={'margin-right-half'}>
          {'Select All'}
        </span>
        <input
          checked={selectAllChecked}
          disabled={!results.length}
          id={`${idRoot}-path-cart-select-all-toggle`}
          onChange={handleChange}
          type={'checkbox'} />
      </label>
      <PathCartToggle idRoot={idRoot} />
    </div>
  )
}

PathDatabaseSearchPathCartTrigger.propTypes = {
  idRoot: string.isRequired,
  results: array.isRequired,
}

export default PathDatabaseSearchPathCartTrigger
